/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type DeleteVolunteerShiftSignupMutationVariables = Types.Exact<{
  shift_id: Types.Scalars["Int"];
  event_attendee_id: Types.Scalars["Int"];
}>;

export type DeleteVolunteerShiftSignupMutation = {
  deleteShiftSignup: Pick<Types.Success, "status">;
};

export const DeleteVolunteerShiftSignupDocument = gql`
  mutation DeleteVolunteerShiftSignup(
    $shift_id: Int!
    $event_attendee_id: Int!
  ) {
    deleteShiftSignup(
      where: {
        AND: [
          { event_attendee_id: { equals: $event_attendee_id } }
          { shift_id: { equals: $shift_id } }
        ]
      }
    ) {
      status
    }
  }
`;

/**
 * __useDeleteVolunteerShiftSignupMutation__
 *
 * To run a mutation, you first call `useDeleteVolunteerShiftSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolunteerShiftSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolunteerShiftSignupMutation, { data, loading, error }] = useDeleteVolunteerShiftSignupMutation({
 *   variables: {
 *      shift_id: // value for 'shift_id'
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useDeleteVolunteerShiftSignupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVolunteerShiftSignupMutation,
    DeleteVolunteerShiftSignupMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteVolunteerShiftSignupMutation,
    DeleteVolunteerShiftSignupMutationVariables
  >(DeleteVolunteerShiftSignupDocument, baseOptions);
}
export type DeleteVolunteerShiftSignupMutationHookResult = ReturnType<
  typeof useDeleteVolunteerShiftSignupMutation
>;
export type DeleteVolunteerShiftSignupMutationResult =
  ApolloReactCommon.MutationResult<DeleteVolunteerShiftSignupMutation>;
export type DeleteVolunteerShiftSignupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVolunteerShiftSignupMutation,
    DeleteVolunteerShiftSignupMutationVariables
  >;
